// extracted by mini-css-extract-plugin
module.exports = {"root":"TextLink_root__IA0Pr","variant_green":"TextLink_variant_green__SuAqh","variant_white-50p":"TextLink_variant_white-50p__aI3Ii"};